import { Injectable, inject } from '@angular/core';
import { WINDOW } from '@services/utils/window/window.provider';
import { SessionService } from '@services/utils/session.service';
import { Constants } from '@models/index';

type NativeWindow = Window & {
    AndroidBridge?: { closeWebView: () => void };
    webkit?: { messageHandlers?: { polarisNative?: { postMessage: (msg: unknown) => void } } };
};

@Injectable({ providedIn: 'root' })
export class NativeBridgeService {
    private readonly win = inject(WINDOW) as NativeWindow;
    private readonly sessionService = inject(SessionService);

    isNativeContext(): boolean {
        const origin = this.sessionService.getOrigin();
        return origin === 'android' || origin === 'ios';
    }

    closeWebView(): void {
        const payload = { action: Constants.FRAME_ACTION.CLOSE_WEBVIEW };

        if (this.win.AndroidBridge?.closeWebView) {
            this.win.AndroidBridge.closeWebView();
            return;
        }
        if (this.win.webkit?.messageHandlers?.polarisNative) {
            this.win.webkit.messageHandlers.polarisNative.postMessage(payload);
            return;
        }
        this.win.parent?.postMessage(payload, '*');
    }
}
